



























  import { Filter, isBooleanFilter } from '@empathyco/x-types';
  import { mixins } from 'vue-class-component';
  import { Component, Prop, Watch } from 'vue-property-decorator';
  import { xComponentMixin, XProvide } from '../../../../components';
  import { debounce } from '../../../../utils/debounce';
  import { normalizeString } from '../../../../utils/normalize';
  import { DebouncedFunction, VueCSSClasses } from '../../../../utils/types';
  import { facetsXModule } from '../../x-module';
  import FiltersInjectionMixin from './filters-injection.mixin';

  /**
   * Renders the filters sifted with the input query.
   *
   * @public
   */
  @Component({
    mixins: [xComponentMixin(facetsXModule)]
  })
  export default class FiltersSearch extends mixins(FiltersInjectionMixin) {
    /** The debounce time for applying the filter sifting. */
    @Prop({ default: 200 })
    protected debounceInMs!: number;

    protected query = '';
    protected setQueryDebounced!: DebouncedFunction<[string]>;

    protected filtersSearchInputMessage = 'search into the filter values';

    /**
     * Set the debounce function for setting the query debounced.
     *
     * @internal
     */
    @Watch('debounceInMs', { immediate: true })
    updateSetQueryDebounced(): void {
      this.setQueryDebounced = debounce(query => {
        this.query = query;
      }, this.debounceInMs);
    }

    /**
     * Sift the array of filters which matches with the query.
     *
     * @returns Array of sifted filters.
     * @internal
     */
    @XProvide('filters')
    public get siftedFilters(): Filter[] {
      const normalizedQuery = normalizeString(this.query);
      return this.renderedFilters.filter(
        filter => isBooleanFilter(filter) && normalizeString(filter.label).includes(normalizedQuery)
      );
    }

    /**
     * Adds the dynamic css classes to the component.
     *
     * @returns The class to be added to the component.
     * @internal
     */
    protected get cssClasses(): VueCSSClasses {
      return {
        'x-filters-search--is-sifted': !!this.query
      };
    }

    /**
     * Set the query through the debounced function.
     *
     * @param query - The query to sift filters.
     * @internal
     */
    protected setQuery(query: string): void {
      this.setQueryDebounced(query);
    }

    /**
     * Clear the query.
     *
     * @internal
     */
    protected clearQuery(): void {
      this.query = '';
    }
  }
